module.exports = __webpack_public_path__ + "static/img/4.7ee7e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/4.png
// module id = s24K
// module chunks = 1